import { z } from 'zod';
import { PASSWORD_MIN_LENGTH } from '../constants.js';
export const LoginSchema = z.object({
    email: z.string().trim().email().toLowerCase().max(254),
    password: z.string().min(1).max(128), // 密码不 trim
});
export const ChangePasswordSchema = z.object({
    current_password: z.string().min(1).max(128),
    new_password: z.string().min(PASSWORD_MIN_LENGTH).max(128),
});
export const SwitchTenantSchema = z.object({
    tenant_id: z.string().min(1).max(64),
});
/** Login 回應 */
export const LoginResponseSchema = z.object({
    session_jwt: z.string(),
    expires_at: z.number(), // epoch seconds
    user: z.object({
        id: z.string(),
        email: z.string(),
        name: z.string(),
        is_platform_admin: z.boolean(),
    }),
});
/** Switch-tenant 回應 */
export const SwitchTenantResponseSchema = z.object({
    tenant_jwt: z.string(),
    expires_at: z.number(),
    tenant: z.object({
        id: z.string(),
        name: z.string(),
        code: z.string(),
    }),
    role: z.enum(['admin', 'editor', 'viewer']),
});
//# sourceMappingURL=auth.js.map